var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShippingDelivered02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 521 241.7",
    style: {
      enableBackground: "new 0 0 521 241.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFEFEF;}\n\t.st1{fill:none;stroke:#AFAFAF;stroke-width:1.75;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;stroke:#AFAFAF;stroke-width:1.75;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#AFAFAF;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#FFFFFF;stroke:#AFAFAF;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:none;stroke:#AFAFAF;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:none;stroke:#3F3F3F;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:none;stroke:#3F3F3F;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:#FFFFFF;stroke:#3F3F3F;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:#E84D4D;}\n\t.st11{font-family:'Montserrat';}\n\t.st12{font-size:10.2678px;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:0.1402;stroke-miterlimit:10;}\n\t.st14{font-size:15.5668px;}\n\t.st15{fill:none;stroke:#FFFFFF;stroke-width:0.2126;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shipping-page-graphics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 205,
    className: "st0",
    width: 140.5,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 72.8,
    className: "st0",
    width: 29.7,
    height: 19.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.9,29.5h-4.8v3.2c0,0-0.2,15.9-27,15.9v3.2h41.4v-3.2l-9.5-15.9V29.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.9,
    y: 8.9,
    className: "st1",
    width: 128.1,
    height: 212.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "216.4,34.7 246.1,34.7 246.1,78.9 250.1,78.9 250.1,30.7 216.4,30.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "216.4,102 246.1,102 246.1,162.9 250.1,162.9 250.1,98 216.4,98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "216.4,180.1 246.1,180.1 246.1,200.1 250.1,200.1 250.1,176.1 216.4,176.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "264.2,30.7 264.2,34.7 293.9,34.7 293.9,78.9 297.9,78.9 297.9,30.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "264.2,102 293.9,102 293.9,162.9 297.9,162.9 297.9,98 264.2,98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "264.2,180.1 293.9,180.1 293.9,200.1 297.9,200.1 297.9,176.1 264.2,176.1  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 216.4,
    y: 30.7,
    className: "st1",
    width: 33.7,
    height: 48.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.4,
    y: 98,
    className: "st1",
    width: 33.7,
    height: 64.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.4,
    y: 176.1,
    className: "st1",
    width: 33.7,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.2,
    y: 30.7,
    className: "st1",
    width: 33.7,
    height: 48.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.2,
    y: 98,
    className: "st1",
    width: 33.7,
    height: 64.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.2,
    y: 176.1,
    className: "st1",
    width: 33.7,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 205.4,
    cy: 115.4,
    r: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320.2,238c0,0-5.9-32.7,22-35.6c9.4-1,19,6.2,19,6.2s10.6-10.9,24.8-7.2c11.6,3.1,16.4,14.1,16.1,23.2 c0,0,8.7-5.2,15.2,1.7c3.8,4,2.2,11.7,2.2,11.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 221.3,
    className: "st2",
    width: 151.8,
    height: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M347.7,180.1l7,8.9l1.7-0.3c-1.5-2.3-2.8-4.6-3.9-7.1L347.7,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M361.1,188.9l0.6-6.5l1.9-0.6l-0.5,7.8l3.5-7.5l1.7-0.4l-3.9,7.6C364.5,189.3,364.2,191.3,361.1,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M386.8,152.8c-1.8-1.5-5.1-1.2-6.1,0.7c1.4-4.9,2.1-11.3-0.1-15.9c-0.8-1.7-2.1-3-3.7-3.9 c-1.7-0.9-5.4-0.2-6.5,1.4c-1.5-6.3-5-12.1-10.2-12.1c-6.5,0-9.4,5.6-10.2,12.1c-1.1-1.5-4.8-2.3-6.5-1.4c-1.6,0.8-3,2.2-3.7,3.9 c-2.3,4.6-1.5,11-0.1,15.9c-1-1.9-4.3-2.3-6.1-0.7c-2,1.7-2.2,4.6-2,7.2c1.3,12.6,15.2,23.2,28.3,22.7c0,0,0.1,0,0.1,0v0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0v0c0,0,0.1,0,0.1,0c13.2,0.5,27-10.1,28.3-22.7C389,157.4,388.7,154.5,386.8,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.6,168.4c0,0,13.3,9.4,24.2,10s20-3.3,24.4-6.4c-6.3,7.9-16.2,11.9-26.1,10.5c-6.7-0.9-12.5-2.9-16.2-6.8 C340.9,175.7,336.4,172.4,334.6,168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.8,152.8c-1.8-1.5-5.1-1.2-6.1,0.7c1.4-4.9,2.1-11.3-0.1-15.9c-0.8-1.7-2.1-3-3.7-3.9 c-1.7-0.9-5.4-0.2-6.5,1.4c-1.5-6.3-5-12.1-10.2-12.1c-6.5,0-9.4,5.6-10.2,12.1c-1.1-1.5-4.8-2.3-6.5-1.4c-1.6,0.8-3,2.2-3.7,3.9 c-2.3,4.6-1.5,11-0.1,15.9c-1-1.9-4.3-2.3-6.1-0.7c-2,1.7-2.2,4.6-2,7.2c1.3,12.6,15.2,23.2,28.3,22.7c0,0,0.1,0,0.1,0v0 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0v0c0,0,0.1,0,0.1,0c13.2,0.5,27-10.1,28.3-22.7C389,157.4,388.7,154.5,386.8,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M367.2,161.9c-3.5,2-6.3-0.7-5.1-3c-1.6,2.1-4.5,1.7-5.3-0.6c-1.8,4.2-8.3,3.6-9.7-1.2 c-0.7-2.3-0.6-4.7,0.5-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M374.1,168.9c-5.1,7.2-13.1,3.8-15.2,1.4c0,0-1.9,3.3-5.4,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "336.4,191.2 342.2,238.7 377.8,238.7 385.1,191.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.4,
    y: 186.2,
    className: "st2",
    width: 53.6,
    height: 8.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 425.8,
    y1: 238.7,
    x2: 96.5,
    y2: 238.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 429.1,
    y1: 238.7,
    x2: 442.4,
    y2: 238.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 79.5,
    y1: 238.7,
    x2: 93.3,
    y2: 238.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.3,52.2c0,4.2-3.4,7.5-7.5,7.5c-4.2,0-7.5-3.4-7.5-7.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 154.7,
    cy: 16.8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 154.7,
    cy: 16.8,
    r: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.1,2.5v23.9h3.2V2.5c0-0.9-0.7-1.6-1.6-1.6C153.9,0.9,153.1,1.6,153.1,2.5C153.1,2.4,153.1,2.5,153.1,2.5 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 26.3,
    className: "st5",
    width: 9.5,
    height: 3.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "143.6,32.7 165.9,32.7 175.4,48.6 134,48.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 29.5,
    className: "st6",
    width: 22.3,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 48.6,
    className: "st6",
    width: 41.4,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.1,
    y: 29.8,
    className: "st0",
    width: 44.3,
    height: 19.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.9,
    y: 96.3,
    className: "st0",
    width: 44.3,
    height: 19.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.4,
    y: 69,
    className: "st0",
    width: 44.3,
    height: 19.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.4,
    y: 113.9,
    className: "st0",
    width: 44.3,
    height: 19.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "141.7,154.1 141.7,163.7 108.7,163.7 108.7,185.8 91.6,185.8 91.6,238.3 141.7,238.3 141.7,238.3  220,238.3 220,154.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "141.8,163.6 141.8,238.4 122.7,238.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 162.2,
    x2: 142.1,
    y2: 238.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 108.1,
    y1: 186.3,
    x2: 142.1,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "141.7,154.1 141.7,163.7 108.7,163.7 108.7,185.8 91.6,185.8 91.6,238.3 141.7,238.3 141.7,238.3  220,238.3 220,154.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.6,
    y: 154.6,
    className: "st9",
    width: 17.1,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.4,
    y: 186.3,
    className: "st9",
    width: 11.8,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 202.6,
    className: "st10",
    width: 22.4,
    height: 22.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 114.4903 216.5358)",
    className: "st4 st11 st12"
  }, "bcp"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 114.4903 216.5358)",
    className: "st13 st11 st12"
  }, "bcp"), /*#__PURE__*/React.createElement("rect", {
    x: 164.8,
    y: 181.2,
    className: "st10",
    width: 33.9,
    height: 33.9
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 168.3745 202.2663)",
    className: "st4 st11 st14"
  }, "bcp"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 168.3745 202.2663)",
    className: "st15 st11 st14"
  }, "bcp")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingDelivered02);
export default __webpack_public_path__ + "static/media/shipping-delivered-02.68398fc9d775fd1d957b4b6d5d29ee22.svg";
export { ForwardRef as ReactComponent };